import React from 'react';
import { Link } from 'react-router-dom';
import UserContext from '../Context/UserContext';
/**
 * Nav Bar Links
 * Display relevant nav links when user is signed in or signed out
 */
const NavLinks = props => {
  let links = [];

  if (props.loggedIn) {
    links.push(
      <li key='myaccount-link'>
        <Link to='/myaccount'>My Account</Link>
      </li>
    );
  } else {
    links.push(
      <li key='myaccount-link'>
        <Link to='/login'>Login</Link>
      </li>
    );
  }

  links.push(
    <li key='how-it-works'>
      <Link to='/how-it-works'>How It Works</Link>
    </li>
  );

  links.push(
    <li key='pricing'>
      <Link to='/pricing'>Pricing</Link>
    </li>
  );

  links.push(
    <li key='learn' className='dropdown'>
      {/* eslint-disable-next-line */}
      <a
        className='dropdown-toggle'
        data-toggle='dropdown'
        role='button'
        aria-haspopup='true'
        aria-expanded='false'
      >
        Pet Health <span className='caret' />
      </a>
      <ul className='dropdown-menu'>
        {/* eslint-disable-next-line */}
        <li>
          <a href='https://blog.vetchat.com.au'>Blog</a>
        </li>
        {/* eslint-disable-next-line */}
        <li>
          <Link to='/videos'>Videos</Link>
        </li>
        {/* eslint-disable-next-line */}
        <li>
          <Link to='/resources'>Resources</Link>
        </li>
        <li>
          <Link to='/giving'>Giving</Link>
        </li>
      </ul>
    </li>
  );

  links.push(
    <li key='chat-now' className='chat-now'>
      <Link to='/pricing' className='btn btn-vetchat navbar-btn'>
        Chat Now
      </Link>
    </li>
  );

  return links;
};

const NavbarComponent = () => (
  <UserContext.Consumer>
    {context => <NavLinks {...context} />}
  </UserContext.Consumer>
);

export default NavbarComponent;
